<template>
  <div>
    <EditorMenuBar :editor="editor" #default="{ commands, isActive }">
      <div class="text-editor__heading">
        <a-tooltip placement="bottom">
          <template #title>
            Bold
          </template>
          <a-button
            @click="commands.bold"
            icon="bold"
            :class="{
              active: isActive.bold()
            }"
          ></a-button>
        </a-tooltip>

        <a-tooltip placement="bottom">
          <template #title>Italic</template>
          <a-button
            @click="commands.italic"
            icon="italic"
            :class="{
              active: isActive.italic()
            }"
          ></a-button>
        </a-tooltip>
        <a-tooltip placement="bottom">
          <template #title>strikethrough</template>
          <a-button
            @click="commands.strike"
            icon="strikethrough"
            :class="{
              active: isActive.strike()
            }"
          ></a-button>
        </a-tooltip>
        <a-tooltip placement="bottom">
          <template #title>Underline</template>
          <a-button
            @click="commands.underline"
            icon="underline"
            :class="{
              active: isActive.underline()
            }"
          ></a-button>
        </a-tooltip>

        <a-tooltip placement="bottom">
          <template #title>Heading 1</template>
          <a-button
            @click="commands.heading({ level: 1 })"
            class="ml-3 px-2"
            :class="{
              active: isActive.heading({ level: 1 })
            }"
          >H1</a-button>
        </a-tooltip>
        <a-tooltip placement="bottom">
          <template #title>Heading 2</template>
          <a-button
            @click="commands.heading({ level: 2 })"
            class="px-2"
            :class="{
              active: isActive.heading({ level: 2 })
            }"
          >H2</a-button>
        </a-tooltip>
        <a-tooltip placement="bottom">
          <template #title>Heading 3</template>
          <a-button
            @click="commands.heading({ level: 3 })"
            class="px-2"
            :class="{
              active: isActive.heading({ level: 3 })
            }"
          >H3</a-button>
        </a-tooltip>

        <a-tooltip placement="bottom">
          <template #title>Order List</template>
          <a-button
            @click="commands.ordered_list"
            icon="ordered-list"
            class="ml-3"
            :class="{
              active: isActive.ordered_list()
            }"
          ></a-button>
        </a-tooltip>

        <a-tooltip placement="bottom">
          <template #title>Bullet List</template>
          <a-button
            @click="commands.bullet_list"
            icon="unordered-list"
            :class="{
              active: isActive.bullet_list()
            }"
          ></a-button>
        </a-tooltip>

        <a-tooltip placement="bottom">
          <template #title>Undo</template>
          <a-button @click="commands.undo" icon="undo" class="ml-3"></a-button>
        </a-tooltip>
        <a-tooltip placement="bottom">
          <template #title>Redo</template>
          <a-button @click="commands.redo" icon="redo"></a-button>
        </a-tooltip>
      </div>
    </EditorMenuBar>
    <EditorContent :editor="editor" class="text-editor__body" />
  </div>
</template>

<script>
import debounce from 'lodash/debounce'
import { EditorContent, Editor, EditorMenuBar } from 'tiptap'
import {
  Bold,
  Italic,
  HardBreak,
  Underline,
  Heading,
  Blockquote,
  Strike,
  ListItem,
  History,
  OrderedList,
  BulletList,
  Placeholder,
} from 'tiptap-extensions'

export default {
  components: {
    EditorContent,
    EditorMenuBar,
  },
  props: {
    placeholder: {
      type: String,
      default() {
        return 'Write something'
      },
    },
    value: {
      type: String,
      default: '',
    },
  },
  created() {
    this.emitUpdate = debounce((value) => {
      let content = value
      if (content === '<p></p>') content = ''

      this.editorChange = true
      this.$emit('input', content)
      this.$emit('change', content)
    }, 200)
  },
  data() {
    return {
      editorChange: false,
      editor: new Editor({
        extensions: [
          new Bold(),
          new Heading({
            level: [1, 2, 3],
          }),
          new Italic(),
          new Underline(),
          new Blockquote(),
          new Strike(),
          new ListItem(),
          new History(),
          new HardBreak(),
          new OrderedList(),
          new BulletList(),
          new Placeholder({
            showOnlyCurrent: false,
            emptyNodeText: this.placeholder,
          }),
        ],
        content: this.value,
        onUpdate: ({ getHTML }) => {
          this.emitUpdate(getHTML())
        },
        onBlur: ({ event, state, view }) => {
          // console.log({ event, state, view })
          // let content = state.getHTML()
          // if (content === '<p></p>') content = ''

          // this.$emit('change', content)
          // this.$emit('change.value', content)
        },
      }),
    }
  },
  beforeDestroy() {
    this.editor.destroy()
  },
  watch: {
    value(val) {
      const content = val === '<p></p>' ? '' : val
      if (this.editor && !this.editorChange) {
        this.editor.setContent(content, true)
      }
      this.editorChange = false
    },
  },
}
</script>

<style lang="scss">
.text-editor {
  &__heading {
    margin-bottom: 0.5rem;

    button {
      &:not(:last-child) {
        margin-right: 0.5rem;
      }
    }
  }

  &__body {
    .ProseMirror {
      padding: 1rem;
      height: 250px;
      overflow-y: auto;
      border-radius: 4px;
      border: 1px solid #e4e9f0;
      outline: 0;

      &-focused {
        border-color: #78a3ff;
      }

      p {
        margin-bottom: 1rem;
      }

      p.is-editor-empty:first-child::before {
        content: attr(data-empty-text);
        float: left;
        color: #aaa;
        pointer-events: none;
        height: 0;
        font-style: italic;
      }
    }
  }
}
</style>
